import { render } from "./ModulesGrid.vue?vue&type=template&id=710b1c71&scoped=true"
import script from "./ModulesGrid.vue?vue&type=script&lang=js"
export * from "./ModulesGrid.vue?vue&type=script&lang=js"

import "./ModulesGrid.vue?vue&type=style&index=0&id=710b1c71&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-710b1c71"]])

export default __exports__